module.exports = __webpack_public_path__ + "img/cn4-crop.87b0e8ee.jpg";